/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { getNodeType } from "components/Map/NodeMapOverlay";
import { useMapDataContext } from "context/MapDataProvider";

export const usePointNodes = () => {
  const { mapData } = useMapDataContext();
  const allNodes = mapData.mapInfo.flatMap((m) => m.nodes);
  const pointNodes = allNodes.filter(
    (n) => getNodeType(n?.description).type === "NamedNode"
  );
  return pointNodes.map((n, i) => {
    return {
      key: i + 1,
      nodeId: n?.id,
      label: getNodeType(n?.description).label,
    };
  });
};
